import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box } from '@mui/material';
import {
  LocalDrink as LocalDrinkIcon,
  NaturePeople as NaturePeopleIcon,
  Restaurant as RestaurantIcon,
  QueryBuilder as QueryBuilderIcon,
  DirectionsCar as DirectionsCarIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import EnviroImpactCard from '../../../../components/EnviroImpactCard';
import { Colors } from '../../../../assets/theme/Colors';
import { ReactComponent as FoodIcon } from '../../../../assets/svg/food.svg';
import {
  formatNumber,
  formatEnvironmentImpactDistance,
  formatEnvironmentImpactDuration,
} from '../../../../helpers/formatters';
import routes from '../../../../routes';
import LandingDashboardCard from './LandingDashboardCard';

const iconSx = {
  color: Colors.appBar.main,
};
const foodSx = {
  fill: Colors.appBar.main,
};
const cardSx = {
  height: '110px',
  padding: 1,
};

const MyImpactDashboardCard = ({ environmentImpact, isLoading, iconSize = 72, id = '' }) => {
  const history = useHistory();

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
  };
  const environmentImpactDuration = formatEnvironmentImpactDuration(
    environmentImpact && environmentImpact.duration ? environmentImpact.duration : 0
  );
  const environmentImpactDistance = formatEnvironmentImpactDistance(
    environmentImpact && environmentImpact.distance ? environmentImpact.distance : 0
  );

  const handleCardClick = () => history.push(routes.mobileDashboardEnvironmentImpact);

  return (
    <LandingDashboardCard title="My Impact" to={routes.mobileDashboardEnvironmentImpact} id={id}>
      <Slider {...settings}>
        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={environmentImpact && environmentImpact.weight_lbs ? formatNumber(environmentImpact.weight_lbs) : 0}
            title="You've rescued"
            subTitle="pounds of food!"
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
          >
            {/* Sets size to the same values as icons from mui */}
            <FoodIcon viewBox="0 0 48 48" width={iconSize} height={iconSize} style={foodSx} />
          </EnviroImpactCard>
        </Box>

        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={environmentImpact && environmentImpact.meals ? formatNumber(environmentImpact.meals) : 0}
            title="You've delivered"
            subTitle="meals to your community!"
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
          >
            <RestaurantIcon sx={iconSx} fontSize="inherit" />
          </EnviroImpactCard>
        </Box>

        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={environmentImpact && environmentImpact.co2eq ? formatNumber(Math.abs(environmentImpact.co2eq)) : 0}
            title="You've offset"
            subTitle={
              <span>
                pounds of C0<sub>2</sub>eq emissions!
              </span>
            }
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
          >
            <NaturePeopleIcon sx={iconSx} fontSize="inherit" />
          </EnviroImpactCard>
        </Box>

        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={environmentImpact && environmentImpact.water ? formatNumber(Math.abs(environmentImpact.water)) : 0}
            title="You've prevented"
            subTitle="gallons of water from being wasted!"
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
          >
            <LocalDrinkIcon sx={iconSx} fontSize="inherit" />
          </EnviroImpactCard>
        </Box>

        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={formatNumber(environmentImpactDuration.value)}
            title="You've spent"
            subTitle={`${environmentImpactDuration.metric} helping your community!`}
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
            showTooltip
            tooltipText="Hours are calculated as the time spent driving from the pickup location and dropoff location"
          >
            <QueryBuilderIcon sx={iconSx} fontSize="inherit" />
          </EnviroImpactCard>
        </Box>

        <Box onClick={handleCardClick}>
          <EnviroImpactCard
            value={formatNumber(environmentImpactDistance.value)}
            title="You've driven"
            subTitle={`${environmentImpactDistance.metric} bringing surplus food to people in need!`}
            isLoading={isLoading}
            cardStyle={cardSx}
            iconSize={iconSize}
            noShadow
            showTooltip
            tooltipText="Mileage is calculated as the distance between the pickup and dropoff locations"
          >
            <DirectionsCarIcon sx={iconSx} fontSize="inherit" />
          </EnviroImpactCard>
        </Box>
      </Slider>
    </LandingDashboardCard>
  );
};

export default MyImpactDashboardCard;
